import { render } from "./ProductTableRow.vue?vue&type=template&id=4c4ef2d8&ts=true"
import script from "./ProductTableRow.vue?vue&type=script&lang=ts"
export * from "./ProductTableRow.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/olaria-preco/olaria-preco/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__